import {useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {getRoomContext} from 'middleware/analytics/selectors'

import {trackEvent} from '@vio/core/src/analytics/modules/actions'
import {
  Action,
  AnalyticsContext,
  Category,
  Entity,
  Page,
  Team
} from '@vio/core/src/analytics/types/Events'

export const useExpandableListToggle = (roomId: string) => {
  const roomContext = useSelector(state => getRoomContext(state, roomId))
  const dispatch = useDispatch()
  const [isOffersExpanded, setIsOfferExpanded] = useState(false)

  const toggleOffersExpanded = () => {
    setIsOfferExpanded(!isOffersExpanded)

    dispatch(
      trackEvent({
        category: Category.User,
        entity: Entity.SeeMoreRoomOffersButton,
        action: Action.Clicked,
        team: Team.Select,
        page: Page.Accommodation,
        analyticsContext: {
          [AnalyticsContext.RoomContext]: roomContext
        }
      })
    )
  }

  return {
    isOffersExpanded,
    toggleOffersExpanded
  }
}
